export default function Marquee() {
  const items = ["Where Trust meets Vision", "Phaco & LASIK", "Retina & Glaucoma Care", "ECHS Empanelled", "Premium IOLs", "Since Day One, Patient First"];
  const row = [...items, ...items];
  return (
    <section className="py-6 bg-[var(--teal)] text-white overflow-hidden border-y border-white/10" aria-hidden="true">
      <div className="marquee-track">
        {row.map((t, i) => (
          <span key={i} className="font-display text-2xl sm:text-4xl italic px-8 flex items-center gap-8 whitespace-nowrap">
            {t}
            <span className="text-[var(--teal-light)]/60 not-italic">&#10022;</span>
          </span>
        ))}
      </div>
    </section>
  );
}
